import { RunnerPageDescription } from '@Client/runner.directives/common/PageDescription';
import { getService } from '@Client/runner.hooks/useService';
import { IGroupedFlowsForDisplay } from '@Client/runner.services/flows.formatter';
import FlowGroups from '@Client/runner.shared/FlowGroups/FlowGroups';
import { Guid } from '@Shared.Angular/@types/guid';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import React, { useEffect, useState } from 'react';

type Props = {
  searchTerm: string;
};

export const RunnerFlowsSearch = ({ searchTerm }: Props) => {
  const browserUtilsService = getService('browserUtilsService');
  const $state = getService('$state');
  const flowApiService = getService('flowApiService');
  const runnerFlowsFormatter = getService('runnerFlowsFormatter');

  const isMobile = browserUtilsService.isMobileDevice();

  const [isWaitingForData, setIsWaitingForData] = useState(true);
  const [pageHeaderText, setPageHeaderText] = useState('Search Results');
  const [pageDescription, setPageDescription] = useState(`for "${searchTerm}"`);
  const [groups, setGroups] = useState<IGroupedFlowsForDisplay[]>([]);

  useEffect(() => {
    loadSearchResults(searchTerm);
  }, [searchTerm]);

  const onFlowClick = (flowId: Guid) => {
    $state.go(STATE_MAPPINGS.flow, { flowId: flowId });
  };

  const loadSearchResults = async (term: string) => {
    try {
      let groups = await flowApiService.getFlowSearchResults(term);
      groups = groups.filter((g) => g.flows.length > 0);

      if (groups.length === 1 && groups[0].flows.length === 1) {
        $state.go(STATE_MAPPINGS.flow, {
          flowId: groups[0].flows[0].flowId,
          searchJump: true
        });
      } else {
        const formattedGroups =
          runnerFlowsFormatter.setGroupedFlowDisplayProperties(groups);
        setGroups(formattedGroups);
        if (formattedGroups.length === 0) {
          setPageHeaderText('Sorry,');
          setPageDescription(`we can't find any flows that match "${term}"`);
        }
        setIsWaitingForData(false);
      }
    } catch (error) {
      setPageHeaderText('Sorry,');
      setPageDescription(
        `an error occurred while searching, please try again.`
      );
      setIsWaitingForData(false);
    }
  };

  if (isWaitingForData) {
    return null;
  }

  return (
    <div className="search-page runner-page">
      <RunnerPageDescription
        showText={!isMobile}
        pageHeaderText={pageHeaderText}
        pageDescription={pageDescription}
      />

      <div className="runner-page__content">
        <div className="runner-page__content__main-wrapper">
          <div className="runner-page__content__main-content">
            <FlowGroups
              isMobile={isMobile}
              groups={groups}
              onFlowClick={onFlowClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
